
export default {
    name: 'Theme2NoContentAvailable',
    props: {
        mobile: {
            type: Boolean,
            default: false,
        },
    },
}
